export default {
  nav: {
    technology: "ODF Technology",
    solutions: "Solutions",
    partnerships: "Partnerships",
    about: "About",
    contact: "Contact Us",
    home: "Home",
  },
  hero: {
    eyebrow: "NEXT-GENERATION ODF SOLUTIONS",
    headline1: "Innovation,",
    headline2: "delivered in every film.",
    copy: "NORTIS brings advanced orally dissolving film (ODF) products to modern wellness brands and international markets—combining a convenient format with reliable commercial expertise.",
    cta1: "Explore ODF Technology",
    cta2: "Partner with NORTIS",
    trust: "Designed for modern lifestyles. Built for global opportunities.",
    scroll: "Scroll",
  },
  brandline: "Advanced Delivery. Effortless Experience.",
  credibility: {
    title: "A smarter format for a changing world.",
    copy: "Orally dissolving films offer a refined and convenient way to deliver carefully formulated ingredients—without the conventional experience of tablets, capsules, or liquids.",
  },
  whatIsOdf: {
    eyebrow: "THE FORMAT",
    title: "What is ODF?",
    copy: "ODF is an ultra-thin oral film designed to dissolve conveniently in the mouth. Its compact format provides a modern alternative for brands developing portable, user-friendly wellness experiences.",
    benefits: [
      { title: "Thin & portable", desc: "An ultra-slim format that travels effortlessly—in a pocket, a wallet, or a bag." },
      { title: "Water-free experience", desc: "Designed to be used anywhere, anytime, without water or preparation." },
      { title: "Precise presentation", desc: "Each film is an individually presented unit, packaged for consistency." },
      { title: "Built for innovation", desc: "A flexible canvas for modern product concepts and differentiated brand experiences." },
    ],
  },
  whyNortis: {
    eyebrow: "WHY NORTIS",
    title: "More than a product format. A complete market opportunity.",
    copy: "NORTIS is the bridge between ODF innovation and commercial markets—connecting promising products with the partners capable of scaling them.",
    points: [
      { title: "ODF-focused commercial expertise", desc: "A dedicated focus on the orally dissolving film category and its commercial dynamics." },
      { title: "International sourcing & market development", desc: "Identifying opportunities and building routes to market across regions." },
      { title: "Product & brand positioning support", desc: "Helping partners frame ODF concepts for their audiences and channels." },
      { title: "Flexible B2B partnership models", desc: "Distribution, private label, and market development—structured around your goals." },
      { title: "Quality-conscious selection", desc: "Disciplined evaluation of suitability, documentation, and market readiness." },
      { title: "Long-term relationships", desc: "Partnerships built for durable, compounding commercial growth." },
    ],
  },
  solutions: {
    eyebrow: "SOLUTIONS PORTFOLIO",
    title: "A portfolio designed around modern life.",
    copy: "Explore the solution categories NORTIS develops with partners and markets worldwide.",
    viewAll: "View all solutions",
    requestInfo: "Request Product Information",
    possibilitiesLabel: "Development possibilities",
    positioningLabel: "Commercial positioning",
    availabilityLabel: "Market availability",
    targetLabel: "Target market",
    docLabel: "Documentation status",
    sheetLabel: "Information sheet",
    sheetOnRequest: "Available on request",
    demoBadge: "Demonstration concept",
    filterAll: "All",
    pageTitle: "Solutions",
    pageSub: "A filterable portfolio of ODF solution categories—structured so real products can be introduced as partnerships develop.",
    demoNote: "The entries below are demonstration concepts illustrating category direction. Actual commercial products are introduced within active partnerships.",
  },
  comparison: {
    eyebrow: "FORMAT EXPERIENCE",
    title: "How the film format compares.",
    copy: "A neutral look at the practical characteristics of everyday formats.",
    note: "Neutral comparison of practical format characteristics only. Not a statement of clinical performance or effectiveness.",
    formats: ["ODF Film", "Tablets", "Capsules", "Liquids"],
    rows: [
      { label: "Portability", values: [2, 2, 2, 0] },
      { label: "Water-free use", values: [2, 0, 0, 1] },
      { label: "Individual pre-portioned format", values: [2, 2, 2, 0] },
      { label: "Storage convenience", values: [2, 2, 1, 0] },
      { label: "Discreet, on-the-go experience", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "PARTNERSHIP MODELS",
    title: "Three ways to build with NORTIS.",
    cta: "Discuss a Partnership",
    items: [
      { title: "Distribution", desc: "Bring selected ODF products to new territories and commercial networks." },
      { title: "Private Label", desc: "Develop differentiated ODF concepts under a partner's own brand." },
      { title: "Market Development", desc: "Build product positioning, launch strategy, and long-term market presence with NORTIS." },
    ],
  },
  timeline: {
    eyebrow: "HOW COLLABORATION WORKS",
    title: "From first conversation to market growth.",
    steps: [
      { title: "Opportunity Discovery", desc: "We explore your goals, markets, and the ODF concepts that fit them." },
      { title: "Product & Market Alignment", desc: "Matching the right products with the right commercial context." },
      { title: "Commercial Evaluation", desc: "Structuring terms, volumes, and a realistic commercial framework." },
      { title: "Compliance & Launch Preparation", desc: "Reviewing documentation and market requirements before launch." },
      { title: "Distribution & Growth", desc: "Supporting rollout, expansion, and long-term partnership growth." },
    ],
  },
  quality: {
    eyebrow: "QUALITY & RESPONSIBILITY",
    title: "Quality begins with the right questions.",
    copy: "NORTIS evaluates product suitability, documentation, commercial readiness, and market requirements as part of every potential partnership. Product availability and regulatory status may differ by country.",
    placeholder: "Verified quality documentation and certifications will be published here as partnerships progress.",
  },
  global: {
    eyebrow: "GLOBAL OUTLOOK",
    title: "Built for international collaboration",
    copy: "We work with brands, suppliers, distributors, and commercial partners to identify meaningful ODF opportunities across evolving global markets.",
  },
  finalCta: {
    title: "Let's shape the next generation of oral wellness.",
    copy: "Whether you are exploring distribution, private label, or a new ODF product concept, NORTIS is ready to start the conversation.",
    cta: "Start a Conversation",
  },
  footer: {
    desc: "NORTIS connects innovative ODF products with brands, partners, and markets worldwide.",
    nav: "Navigate",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    language: "Language",
    disclaimer: "Product availability, formulation, classification, and regulatory status may vary by country. Information on this website is intended for commercial and general informational purposes and does not constitute medical advice.",
    rights: "All rights reserved.",
  },
  tech: {
    eyebrow: "ODF TECHNOLOGY",
    title: "The science of thin.",
    sub: "An educational overview of orally dissolving film—the format, the experience, and the commercial possibilities it opens.",
    what: {
      title: "What is an orally dissolving film?",
      copy: "An orally dissolving film (ODF) is an ultra-thin sheet designed to dissolve conveniently in the mouth. Instead of swallowing a tablet or measuring a liquid, the user simply places a single film and lets it dissolve—a quiet, modern experience in a remarkably compact format.",
    },
    structure: {
      title: "The general film structure",
      copy: "Conceptually, an ODF combines a structural film base, a carrier matrix holding the formulated ingredients, and the sensory layer shaping taste and texture. Hover or tap the diagram to separate the conceptual layers.",
      note: "Conceptual representation for illustration only.",
      layers: [
        { title: "Sensory layer", desc: "Shapes taste, texture, and the dissolution experience." },
        { title: "Carrier matrix", desc: "Holds the carefully formulated ingredients within the film." },
        { title: "Structural base", desc: "Gives the film its integrity, thinness, and stability." },
      ],
    },
    experience: {
      title: "The user experience",
      copy: "No water. No measuring. No interruption. A film dissolves discreetly, making it natural to use while travelling, working, or on the move. For modern consumers, the format itself becomes part of the brand experience.",
    },
    portability: {
      title: "Portability & packaging potential",
      copy: "Individual films can be presented in slim sachets, elegant multi-packs, or compact dispensers—formats that fit modern retail shelves and direct-to-consumer unboxing moments alike.",
    },
    development: {
      title: "Product development possibilities",
      copy: "The film format supports a wide range of product concepts—from daily wellness routines to targeted lifestyle positioning—giving brands room to differentiate in crowded categories.",
    },
    commercial: {
      title: "Commercial applications",
      copy: "ODF concepts are being developed across wellness, beauty-from-within, energy, sleep, and functional ingredient categories—channels where convenience and premium experience drive purchasing decisions.",
    },
    regulatory: {
      title: "Market & regulatory considerations",
      copy: "Classification and requirements for film products differ by country and by formulation. NORTIS approaches every market individually, reviewing documentation and regulatory context with partners before commercialization.",
    },
    cta: "Request Technical Information",
  },
  partnership: {
    eyebrow: "PRIVATE LABEL & DISTRIBUTION",
    title: "Two paths. One standard of partnership.",
    sub: "NORTIS structures commercial collaborations around two primary models—each designed for clarity, speed, and long-term growth.",
    plTitle: "Private Label",
    plDesc: "Develop differentiated ODF concepts under your own brand, with NORTIS coordinating the journey from concept to shelf.",
    plSteps: ["Concept evaluation", "Product selection", "Branding & packaging coordination", "Documentation review", "Market launch preparation", "Commercial scaling"],
    distTitle: "Distribution",
    distDesc: "Bring selected ODF products to your territory and commercial network, with structured support at every stage.",
    distSteps: ["Territory evaluation", "Portfolio alignment", "Commercial terms", "Market-entry planning", "Launch support", "Long-term growth"],
    formTitle: "Start a partnership inquiry",
    formSub: "Tell us about your goals and our team will respond with the next steps.",
  },
  about: {
    eyebrow: "ABOUT NORTIS",
    title: "Focused on the format shaping tomorrow.",
    copy: "NORTIS was created to connect promising ODF innovations with the brands, partners, and markets capable of turning them into meaningful commercial products. We combine entrepreneurial speed, international thinking, and a disciplined approach to long-term partnerships.",
    positioning: "NORTIS connects innovative ODF products with brands, partners, and markets worldwide.",
    principlesTitle: "Our principles",
    principles: [
      { title: "Precision", desc: "Care in every detail—from product evaluation to partner communication." },
      { title: "Trust", desc: "Transparent expectations and commitments we intend to keep." },
      { title: "Progress", desc: "A bias toward forward motion and modern formats." },
      { title: "Partnership", desc: "Relationships designed to compound over years, not quarters." },
      { title: "Global Perspective", desc: "Thinking across borders, markets, and consumer cultures." },
    ],
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Let's start the conversation.",
    sub: "Share a few details about your interest and our team will get back to you.",
    name: "Full name",
    company: "Company",
    email: "Business email",
    country: "Country",
    website: "Website",
    interest: "Partnership interest",
    market: "Expected market or territory",
    message: "Message",
    consent: "I consent to NORTIS storing my details in order to respond to this inquiry.",
    submit: "Send Message",
    sending: "Sending…",
    successTitle: "Thank you — message received.",
    successCopy: "Our team will review your inquiry and get back to you shortly.",
    successAnother: "Send another message",
    errorRequired: "This field is required.",
    errorEmail: "Please enter a valid business email.",
    errorConsent: "Consent is required to submit the form.",
    errorSubmit: "Something went wrong. Please try again.",
    optional: "Optional",
    interests: {
      distribution: "Distribution",
      privateLabel: "Private label",
      sourcing: "Product sourcing",
      marketDev: "Market development",
      general: "General partnership",
      product: "Product information",
      technical: "Technical information",
    },
    selectPlaceholder: "Select an option",
  },
  legal: {
    privacyTitle: "Privacy Policy",
    termsTitle: "Terms of Use",
    updated: "Last updated",
    privacy: [
      { h: "1. Overview", p: "This Privacy Policy explains how NORTIS collects, uses, and protects information submitted through this website. We are committed to handling business contact information responsibly and transparently." },
      { h: "2. Information we collect", p: "When you submit a contact or partnership form, we collect the information you provide, such as your name, company, business email, country, website, area of interest, and message content." },
      { h: "3. How we use information", p: "Submitted information is used solely to respond to your inquiry, evaluate potential commercial collaboration, and communicate with you about relevant partnership matters. We do not sell personal information." },
      { h: "4. Data storage & security", p: "Form submissions are stored securely in our application database. Access is limited to personnel who need it to respond to inquiries. We take reasonable technical measures to protect stored data." },
      { h: "5. Data retention", p: "We retain inquiry data for as long as necessary to manage the business relationship or as required by applicable law. You may request deletion of your data by contacting us." },
      { h: "6. Your rights", p: "Depending on your jurisdiction, you may have rights to access, correct, or delete personal data we hold about you. To exercise these rights, please contact us through the website." },
      { h: "7. Changes to this policy", p: "We may update this Privacy Policy from time to time. Material changes will be reflected on this page with an updated revision date." },
    ],
    terms: [
      { h: "1. Acceptance of terms", p: "By accessing and using this website, you agree to these Terms of Use. If you do not agree, please discontinue use of the site." },
      { h: "2. Informational purpose", p: "Content on this website is provided for commercial and general informational purposes only. It does not constitute medical, legal, or regulatory advice, and no content should be interpreted as a product claim." },
      { h: "3. Product availability", p: "Product availability, formulation, classification, and regulatory status may vary by country. Nothing on this website constitutes an offer to sell any product in any specific jurisdiction." },
      { h: "4. Intellectual property", p: "The NORTIS name, visual identity, and website content are the property of NORTIS. You may not reproduce or distribute site content without prior written permission." },
      { h: "5. Limitation of liability", p: "NORTIS makes reasonable efforts to keep website information accurate, but does not warrant its completeness. To the extent permitted by law, NORTIS is not liable for decisions made based on website content." },
      { h: "6. Third-party links", p: "This website may contain links to third-party resources. NORTIS is not responsible for the content or practices of external sites." },
      { h: "7. Governing use", p: "These terms may be updated periodically. Continued use of the website constitutes acceptance of the current version." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Advanced ODF Solutions | Orally Dissolving Film Partner", desc: "NORTIS connects innovative orally dissolving film (ODF) products with brands, partners, and markets worldwide. Distribution, private label, and market development." },
    tech: { title: "ODF Technology — NORTIS", desc: "An educational overview of orally dissolving film technology: format, structure, user experience, and commercial possibilities." },
    solutions: { title: "ODF Solutions Portfolio — NORTIS", desc: "Explore ODF solution categories: daily wellness, energy, beauty, sleep, functional ingredients, and custom private-label concepts." },
    partnership: { title: "Private Label & Distribution — NORTIS", desc: "Partner with NORTIS through distribution, private label, or market development models for ODF products." },
    about: { title: "About NORTIS — Focused on the Format Shaping Tomorrow", desc: "NORTIS connects promising ODF innovations with the brands, partners, and markets capable of turning them into commercial products." },
    contact: { title: "Contact NORTIS — Start a Conversation", desc: "Reach the NORTIS team to discuss ODF distribution, private label, sourcing, or market development." },
    privacy: { title: "Privacy Policy — NORTIS", desc: "How NORTIS collects, uses, and protects information submitted through this website." },
    terms: { title: "Terms of Use — NORTIS", desc: "Terms governing the use of the NORTIS website and its informational content." },
  },
  a11y: {
    mainNav: "Main navigation",
    mobileNav: "Mobile navigation",
    homeLink: "NORTIS home",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    langSelector: "Select language",
    filmDiagram: "Interactive film layer diagram",
    linkedinLabel: "NORTIS on LinkedIn",
    techImageAlt: "Abstract layered film sheets",
    yes: "Yes",
    partial: "Partial",
    no: "No",
    filters: "Solution filters",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Daily Wellness",
      desc: "Everyday film concepts designed to slot naturally into modern morning and evening routines.",
      possibilities: ["Routine-based product lines", "Subscription-friendly formats", "Minimalist premium packaging"],
      positioning: "Positioned for consumers seeking effortless daily consistency.",
      availability: "In development with partners",
      targetMarket: "Wellness & lifestyle retail",
      docStatus: "Prepared per market",
    },
    "energy-performance": {
      name: "Energy & Performance",
      desc: "On-the-go concepts for consumers who value momentum—before training, travel, or a demanding day.",
      possibilities: ["Pre-activity positioning", "Compact multi-pack formats", "Bold, modern brand language"],
      positioning: "Built for speed-first, convenience-driven consumption moments.",
      availability: "In development with partners",
      targetMarket: "Active lifestyle & sports channels",
      docStatus: "Prepared per market",
    },
    "beauty-aging": {
      name: "Beauty & Healthy Aging",
      desc: "Elegant film concepts for the beauty-from-within category, where experience and aesthetics matter.",
      possibilities: ["Premium beauty positioning", "Giftable packaging concepts", "Ritual-led brand storytelling"],
      positioning: "A refined format for brands elevating the daily beauty ritual.",
      availability: "In development with partners",
      targetMarket: "Beauty-from-within & premium retail",
      docStatus: "Prepared per market",
    },
    "sleep-relaxation": {
      name: "Sleep & Relaxation",
      desc: "Calm, evening-oriented concepts designed around simplicity at the end of the day.",
      possibilities: ["Evening ritual positioning", "Discreet bedside formats", "Soothing sensory design"],
      positioning: "Made for the quiet moment before rest.",
      availability: "In development with partners",
      targetMarket: "Evening wellness & pharmacy retail",
      docStatus: "Prepared per market",
    },
    "vitamins-functional": {
      name: "Vitamins & Functional Ingredients",
      desc: "Film concepts built around established functional ingredients, presented in a precise modern format.",
      possibilities: ["Ingredient-led product families", "Clear, honest label design", "Format-first differentiation"],
      positioning: "A contemporary alternative within established ingredient categories.",
      availability: "In development with partners",
      targetMarket: "Nutraceutical & functional retail",
      docStatus: "Prepared per market",
    },
    "custom-private-label": {
      name: "Custom & Private-Label Concepts",
      desc: "A blank canvas: bespoke ODF concepts developed under a partner's own brand, from idea to launch.",
      possibilities: ["Fully bespoke concept development", "Brand & packaging coordination", "Launch and scaling support"],
      positioning: "For partners who want a differentiated product that is unmistakably theirs.",
      availability: "Open for briefs",
      targetMarket: "Brand owners & retailers",
      docStatus: "Defined per project",
    },
  },
};
